module.exports = __webpack_public_path__ + "img/iamc_logo.87b7fbe9.png";